<template>
  <el-dialog
    v-el-drag-dialog
    no="writeOffList"
    :visible.sync="innerVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :title="$t('Payment.writeOffList')"
    width="1200px"
    class="app-main-inner write-off-detail-dialog"
  >
    <div class="section grid-wrapper" style="width: 100%;">
      <cargo-ag-grid
        no="191003-gird"
        config-module="191003"
        :grid-params.sync="gridParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div slot="footer">
      <span style="position: absolute; left: 0; padding-left: 10px;">
        <span>{{ $t('WriteOff.totalWriteOffs') }}</span>
        <charge-currency-total-group
          v-if="!isBill && reCalc"
          ar-field="ar"
          currency-field="clearCurrency"
          data-field="clearAmount"
          :type="totalGroupType"
          :data-provider="totalGroup"
          :amount-to-currency-label="$t('WriteOff.totalWriteOffs')"
        />
        <!--        <span>{{ $t('WriteOff.totalEquivalent') }}</span>-->
        <!--        <charge-currency-total-group-->
        <!--          v-if="!isBill"-->
        <!--          ar-field="ar"-->
        <!--          currency-field="currency"-->
        <!--          data-field="amount"-->
        <!--          amount-to-currency="RMB"-->
        <!--          rate-field="rate"-->
        <!--          type="revenueAbs"-->
        <!--          amount-to-currency-label="折合"-->
        <!--          :data-provider="totalGroup2"-->
        <!--        />-->
      </span>
      <span>
        <!--部分撤销销账-->
        <el-button v-if="false" no="cancelPartialWriteOff" type="primary" @click="onPartRollback">{{ $t('WriteOff.cancelPartialWriteOff') }}</el-button>
        <!--导出Excel-->
        <el-button no="exportToExcel" type="primary" @click="onExport"><svg-icon icon-class="excel" style="font-size: 12px;vertical-align: bottom" />{{ $t('WriteOff.exportToExcel') }}</el-button>
        <!--导出PDF-->
        <el-button no="exportPDF" type="primary" @click="onExportPdf"><svg-icon icon-class="excel" style="font-size: 12px;vertical-align: bottom" />{{ $t('WriteOff.exportPDF') }}</el-button>
        <!--打印-->
        <el-button no="print" type="primary" @click="onPrint">{{ $t('WriteOff.print') }}</el-button>
      </span>
    </div>
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.cxt"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
    />
  </el-dialog>
</template>

<script>
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import DateUtils from '@/utils/dateUtils'
import { ChargeItem } from '@/class/model/mdm/chargeItem'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import ChargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import * as writeoffApi from '@/api/act/writeoff'
import StrUtils from '@/utils/StrUtils'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import URL from '@/api/urlTranslator'
import { getToken } from '@/utils/auth'
import lodash from 'lodash'
import { getLoading } from '@/utils/utilBaseElement'
import * as actualAmountApi from '@/api/clearing/actualAmount'
import { exportExcel } from '@/utils/tableDataExportUtils'

export default {
  name: 'ChargeWriteOffDetailDialog',
  components: { CargoAdvanceSelect, ChargeCurrencyTotalGroup, cargoTemplateSelectorDialog },
  props: {
    visible: { type: Boolean, required: true },
    actualAmountUuid: { type: String, required: true },
    isBill: { type: Boolean, required: true },
    isAr: { type: Boolean, required: true },
    isSetoff: { type: Boolean, required: true },
    totalGroupType: { type: String, default: 'ar' }
  },
  data() {
    return {
      totalGroup: null,
      totalGroup2: null,
      clickRow: null,
      clearAmountDebit: null,
      amountCredit: null,
      clearAmountCredit: null,
      nsClearOdd: null,
      nsDiffChange: null,
      nsFinancialCost: null,
      actualAmount: null,
      loading: false,
      innerVisible: false,
      gridParams: {},
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true,
          filter: false
        },
        pagination: false,
        onRowClicked: this.rowClicked
      },
      columnDefs: [{
        headerName: this.$t('Payment.settleAccountsTo'),
        field: 'accountId',
        colId: 'accountId',
        width: 140,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('Payment.mbl'),
        field: 'mbl',
        colId: 'mbl',
        cellRenderer: params => {
          return params.value + ' '
        }, width: 120
      }, {
        headerName: this.$t('Payment.vesselAndVoyage'),
        field: 'vesselFlight',
        colId: 'vesselFlight',
        width: 140
      }, {
        headerName: this.$t('Payment.containerSizeAmount'),
        field: 'containerDesc',
        colId: 'containerDesc',
        width: 120
      }, {
        headerName: this.$t('Payment.businessDate'),
        field: 'businessDate',
        colId: 'businessDate',
        width: 110,
        cellRenderer: (params) => {
          return DateUtils.customFormat(params.value, DateUtils.STANDARD_DATE)
        }
      }, {
        headerName: this.$t('Payment.chargeItem'),
        field: 'chargeItemId',
        colId: 'chargeItemId',
        width: 110,
        cellRenderer: (params) => {
          return this.chargeNameLabelFun(params.data, params.value)
        }
      }, {
        headerName: this.$t('Payment.writeOffCurrency'),
        field: 'clearCurrency',
        colId: 'clearCurrency',
        width: 110
      }, {
        headerName: this.$t('Payment.theAmountOfWriteOffs'),
        field: 'clearAmount',
        colId: 'clearAmount',
        width: 110,
        cellRenderer: (params) => {
          return Number(params.value).toFixed(2)
        }
      }, {
        headerName: this.$t('Payment.writeOffExchangeRate'),
        field: 'clearRate',
        colId: 'clearRate',
        width: 110,
        cellRenderer: (params) => {
          return Number(params.value).toFixed(8)
        }
      }, {
        headerName: this.$t('Payment.chargeOriginalCurrency'),
        field: 'currency',
        colId: 'currency',
        width: 120
      }, {
        headerName: this.$t('Payment.chargeOriginalAmount'),
        field: 'amount',
        colId: 'amount',
        width: 120,
        cellRenderer: (params) => {
          return Number(params.value).toFixed(2)
        }
      }, {
        headerName: this.$t('Payment.chargeOriginalExchangeRate'),
        field: 'rate',
        colId: 'rate',
        width: 120,
        cellRenderer: (params) => {
          return Number(params.value).toFixed(8)
        }
      }, {
        headerName: this.$t('Payment.invoiceNo'),
        field: 'invoiceNo',
        colId: 'invoiceNo',
        cellRenderer: params => {
          return params.value + ' '
        }, width: 110
      }, {
      //   headerName: this.$t('Payment.billNo'),
      //   field: 'billingNo',
      //   suppressMenu: true,
      //   width: 100,
      //   hide: true
      // }, {
        headerName: this.$t('Payment.sales'),
        field: 'sales',
        colId: 'sales',
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', Number(params.value), 'chineseName')
        }
      }, {
        headerName: this.$t('Payment.operation'),
        field: 'op',
        suppressMenu: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('Payment.customerService'),
        field: 'csr',
        suppressMenu: true,
        width: 100,
        cellRenderer: (params) => {
          return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
        }
      }, {
        headerName: this.$t('SeaExport.BusinessNo'),
        field: 'jobNo',
        suppressMenu: true,
        width: 120
      }],
      rowData: [],
      templateSelectorDialog: {// 模板选择弹窗
        visible: false,
        ctx: null,
        category: '',
        data: {}
      },
      reCalc: true // 核销总计重算
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      if (newVal) {
        this.startLoad()
      } else {
        this.$emit('update:visible', newVal)
      }
    },
    totalGroupType(newVal, oldVal) {
      if (newVal !== oldVal) {
        setTimeout(() => { this.reCalc = false }, 100)
        setTimeout(() => { this.reCalc = true }, 100)
      }
    }
  },
  methods: {
    chargeNameLabelFun(data, value) {
      const chargeItem = ChargeItem.getChargeItemById(value)
      if (chargeItem) {
        return this.$store.getters.language === 'zh' ? chargeItem.zhName : chargeItem.enName
      }
      return ''
    },
    startLoad() {
      writeoffApi.queryActualAmountsByID([this.actualAmountUuid]).then(res => {
        const rowData = res.data
        for (const obj of rowData) {
          obj.convertAmount = obj.amount * obj.rate
          this.nsClearOdd = obj.clearOdd
          this.nsDiffChange = obj.diffChange
          this.nsFinancialCost = obj.financialCost

          if (obj.ar) {
            this.amountDebit = obj.amount
            this.clearAmountDebit = obj.clearAmount
          } else {
            this.amountCredit = obj.amount
            this.clearAmountCredit = obj.clearAmount
          }
        }
        this.rowData = rowData
        this.totalGroup = this.totalGroup2 = rowData

        // 默认选中第一个
        if (this.rowData[0]) {
          const data = this.rowData[0]
          this.rowClicked({ data })
        }
      }).catch(() => this.faultHandler())
    },
    faultHandler() {
      this.$message.warning(this.$t('CargoMsg.Cargo_SystemBusyPRL'))
    },
    queryOurBankLabelFunc(data) {
      let text = data.ourBank
      if (data.ourBank === '' || data.ourBank === null) {
        for (const bankAccount of this.bankAccounts) {
          if (bankAccount.accountNo === data.ourBankAccount && bankAccount.currency === data.currency) {
            text = bankAccount.bankChineseName
            break
          }
        }
      }
      return text
    },
    rowClicked(event) {
      this.clickRow = event.data
      this.receiveTypeLabel = (this.clickRow.ar ? this.$t('Payment.receipt') : this.$t('Payment.payment')) + this.$t('WriteOff.method')
      this.amountLabel = this.clickRow.ar ? this.$t('WriteOff.receiptAmount') : this.$t('WriteOff.paymentAmount')
    },
    // 导出Pdf
    onExportPdf() {
      const queryResult = lodash.cloneDeep(this.rowData)
      if (queryResult && queryResult.length > 0) {
        const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
        // 表头
        const headers = []
        let field
        let headerName
        for (const column of allDisplayedColumns) {
          field = column.colDef.field
          headerName = column.colDef.headerName
          headers.push({ field, headerName })
        }
        // 数据渲染
        for (const item of queryResult) {
          for (const column of allDisplayedColumns) {
            const colDef = column.colDef
            const dataField = colDef.field
            // 进行labelFunction 处理
            if (colDef.cellRenderer && typeof colDef.cellRenderer !== 'string') {
              const params = { data: item, value: item[dataField] }
              item[dataField] = colDef.cellRenderer(params)
            }
          }
        }
        // form表单请求
        const url = URL.report.exportPdf + '?sessionId=' + getToken()
        const params = {}
        params.tableHeader = JSON.stringify(headers)
        params.tableBody = JSON.stringify(queryResult)
        this.navigateToURL(url, params)
      } else {
        this.$message.info(this.$t('CargoMsg.Cargo_NoData'))
      }
    },
    // 导出Excel
    async onExport() {
      const queryResult = this.rowData
      if (queryResult && queryResult.length > 0) {
        await this.$confirm(this.$t('CargoMsg.Cargo_LoadedAndSave'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          closeOnPressEscape: false,
          type: 'info'
        }).then(() => {
          this.exportHandler(queryResult)
        }).catch(() => {})
      } else {
        this.$message.info(this.$t('CargoMsg.Cargo_NoData'))
      }
    },
    // 导出excel操作处理器
    exportHandler() {
      const rowData = this.rowData
      const self = this
      if (!rowData || rowData.length === 0) {
        self.$message.warning(this.$t('CargoMsg.Cargo_NoData'))
        return
      }
      const rows = lodash.cloneDeep(rowData)
      const timestamp = new Date().getTime()
      console.log('====开始时间======', timestamp)
      // 获取选中行
      const fileName = this.$t('Clearing.SingleWriteOffDetailXls')
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, allDisplayedColumns, true)
    },
    async onPrint() {
      await this.$confirm(this.$t('CargoMsg.Cargo_SureToPrintDetailList'), this.$t('CargoMsg.Cargo_ConfirmR'), {
        confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
        cancelButtonText: this.$t('CargoMsg.Cargo_No'),
        showClose: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        const param = {}
        param.ACT_ACTUAL_AMOUNT_UUID = this.actualAmountUuid
        this.templateSelectorDialog.data = param
        this.templateSelectorDialog.category = 'WRITEOFFDETAILS'
        this.templateSelectorDialog.visible = true
        // TemplateSelectorWin.getInstance().showThisWin(null, "WRITEOFFDETAILS", {ACT_ACTUAL_AMOUNT_UUID : _actualAmount.key}, this);
      }).catch(() => {})
    },
    // form表单请求方法
    navigateToURL(URL, PARAMS) {
      const form = document.createElement('form')
      form.action = URL
      form.method = 'post'
      form.style.display = 'none'
      for (const key in PARAMS) {
        const opt = document.createElement('textarea')
        opt.name = key
        opt.value = PARAMS[key]
        form.appendChild(opt)
      }
      form.target = '_blank'
      document.body.appendChild(form)
      form.submit()
    },
    async onPartRollback() {
      // 获取勾选行
      const selectedRows = this.gridOptions.api.getSelectedRows()
      const clearHistoryUuids = selectedRows.filter(row => row.uuid)
      if (clearHistoryUuids.length === 0) {
        this.$message.info(this.$t('CargoMsg.Cargo_PSEDTRWO'))
        return
      }
      if (clearHistoryUuids.length === this.rowData.length) {
        this.$message.info(this.$t('CargoMsg.Cargo_TRNAPUCWOFISI'))
        return
      }
      this.loading = getLoading()
      if (!this.isAr) {
        const params = {}
        params.actualAmountUuid = this.actualAmountUuid
        params.clearHistoryUuids = clearHistoryUuids
        await actualAmountApi.rollbackBillPayments(params).then(resp => {
          this.rollbackSuccess()
        }).catch(() => this.faultHandler())
        // ActualAmount.rollbackBillPayments(_actualAmountUUID, keys, new mx.rpc.Responder(rollbackSuccess, ClearingConst.defaultErrorHandler));
      } else {
        await writeoffApi.rollbackChargeWriteoff({ actualAmountUuid: this.actualAmountUuid }).then(res => {
          this.rollbackSuccess()
        }).catch(() => this.faultHandler())
        // ActualAmount.rollbackChargeWriteoff(_actualAmountUUID, new mx.rpc.Responder(rollbackSuccess, ClearingConst.defaultErrorHandler));
      }
      this.loading.close()
    },
    rollbackSuccess() {
      this.$message.success(this.$t('CargoMsg.Cargo_WriteOffRevokedSuccessfully'))
      this.startLoad()
    }
  }
}
</script>

<style lang="scss">
.write-off-detail-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
  .custom-el-form-item-color-red {
    .el-form-item__label {
      color: #990000;
    }
    .el-form-item__content {
      .el-input input {
        color: #990000;
      }
    }
  }
  .custom-el-form-item-color-green {
    .el-form-item__label {
      color: #009900;
    }
    .el-form-item__content {
      .el-input input {
        color: #009900;
      }
    }
  }
}
</style>
